export default __webpack_public_path__ + "static/media/icons8-user-folder (1).a4d85931.svg";